import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { MultiSelect } from "primereact/multiselect";
import { JVDate } from "../../shared/JVDate";
import {
  IBranchMastDropdown,
  ICompanyMastDropdown,
  IUsersDropdown,
} from "../../models/IDropdown";
import { ILogin } from "../../models/Login";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInput } from "../../shared/JVInput";

export interface IFilter {
  subscribeStatus:boolean| null ;
  companyId?: number[] | null;
  branchId?: number[] | null;
  userId?: number[] | null; 
  requested_Status?: number | null;
  requested_Email_Status?: number | null;
  vendor_Company_Name?:string | null;
}

interface IProps {
  filters: IFilter;
  setFilters: React.Dispatch<React.SetStateAction<IFilter>>;
}

export const EmptyFilter: IFilter = {
  subscribeStatus:null,
  companyId: [],
  branchId: [],
   userId: [],
  vendor_Company_Name:""
};

export const Filter = (props: IProps) => {
  const [companyList, setCompanyList] = useState<Array<ICompanyMastDropdown>>();
  const [branchList, setBranchList] = useState<Array<IBranchMastDropdown>>();
  const [selectedCompany, setSelectedCompany] = useState<Array<number>>([]);
  const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);
  const [selectedUsers, setSelectedUsers] = useState<Array<number>>([]);
  const [userList, setUserList] = useState<Array<IUsersDropdown>>([]);

  const { control, handleSubmit, reset } = useForm<IFilter>({
    defaultValues: props.filters,
  });

  const _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  const loadCompanies = async () => {
    const response = await Fetch("Dropdown/company", "GET", null, null, null);
    if (response) {
      const data: Array<ICompanyMastDropdown> = await response.json();
      const emptyData = {
        company_ID: 0,
        company_Name: "-- SELECT --",
      };
      data.unshift(emptyData);
      setCompanyList(data);
    }
  };

  const loadBranches = async (company: number[] | null) => {
    let queryParam =
      company !== null && company.length >= 1
        ? `company_id=${company.join(",")}`
        : null;

    const response = await Fetch(
      "Dropdown/multiCompbranches",
      "GET",
      null,
      queryParam,
      null,
    );
    if (response) {
      const data: Array<IBranchMastDropdown> = await response.json();
      const emptyData = {
        branch_ID: 0,
        branchName: "-- SELECT --",
        company_ID: 0,
      };
      data.unshift(emptyData);
      setBranchList(data);
    }
  };

  const loadUsers = async (
    branch: number[] | null | undefined,
    company: number[] | null | undefined,
  ) => {
    let queryParameter = null;
    if (branch?.length !== 0 && branch != null) {
      queryParameter = `branch_IDs=${branch}`;
    } else if (company?.length !== 0 && company != null) {
      queryParameter = `company_IDs=${company}`;
    }

    const response = await Fetch(
      "Dropdown/getUserByCompBranch",
      "GET",
      null,
      queryParameter,
      null,
    );
    if (response) {
      const data: Array<IUsersDropdown> = await response.json();
      const emptyData = {
        login_ID: 0,
        user_Name: "-- SELECT --",
      };
      data.unshift(emptyData);
      setUserList(data);
    }
  };

  useEffect(() => {
    loadCompanies();
  }, []);

  useEffect(() => {
    loadBranches(selectedCompany);
  }, [selectedCompany]);

  useEffect(() => {
    loadUsers(selectedBranch, selectedCompany);
  }, [selectedCompany, selectedBranch]);

  const onSubmit = async (data: IFilter) => {
    // console.log(selectedCompany);
    // console.log(selectedBranch);
    const newData = {
      ...data,
      branchId: selectedBranch,
      companyId: selectedCompany,
      userId: selectedUsers,
    };
    props.setFilters(newData);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
      <JVDropdown
        column={6}
        label="Subscribe Status"
        control={control}
        name="subscribeStatus"
        options={[
          { label: "-- Select --", value: null },
          { label: "Subscribed", value: true },
          { label: "Unsubscribed", value: false },
        ]}
        optionLabel="label"
        optionValue="value"
        placeholder="Select Subscribe Status"
      />
      <JVInput
        column={6}
        label=" Vendor Company"
        control={control}
        name="vendor_Company_Name"
      />

      {_roles.includes(1) || _roles.includes(26) ? (
        <div className="field col-2 md:col-2">
          <p>Company</p>
          <MultiSelect
            className=""
            style={{ height: "37px", marginTop: "-10px" }}
            value={selectedCompany}
            onChange={(e) => setSelectedCompany(e.value)}
            options={companyList}
            optionValue="company_ID"
            optionLabel="company_Name"
            display="chip"
            filter
            placeholder="Select Company"
          />
        </div>
      ) : (
        <></>
      )}
      {_roles.includes(1) || _roles.includes(26) ? (
        <div className="field col-2 md:col-2">
          <p>Branch</p>
          <MultiSelect
            className=""
            style={{ height: "37px", marginTop: "-10px" }}
            value={selectedBranch}
            onChange={(e) => setSelectedBranch(e.value)}
            options={branchList}
            optionValue="branch_ID"
            optionLabel="branchName"
            display="chip"
            filter
            placeholder="Select Branches"
          />
        </div>
      ) : (
        <></>
      )}
      {_roles.includes(1) || _roles.includes(26) ? (
        <div className="field col-2 md:col-2">
          <p>User</p>
          <MultiSelect
            className=""
            style={{ height: "37px", marginTop: "-10px" }}
            value={selectedUsers}
            onChange={(e) => setSelectedUsers(e.value)}
            options={userList}
            optionValue="login_ID"
            optionLabel="user_Name"
            display="chip"
            filter
            placeholder="Select User"
          />
        </div>
      ) : (
        <></>
      )}

      <div style={{ margin: "10px 0", width: "100%" }}></div>

      <div
        className="col-12 md:col-12"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          columnGap: "10px",
          marginTop: "10px",
        }}
      >
        <Button
          className="field col-12 md:col-6"
          label="SEARCH"
          type="submit"
        ></Button>
        <Button
          className="field col-12 md:col-6 p-button-outlined"
          label="CLEAR"
          onClick={() => {
            reset(EmptyFilter);
            setSelectedBranch([]);
            setSelectedCompany([]);
            setSelectedUsers([]);
          }}
          type="button"
        ></Button>
      </div>
    </form>
  );
};
